import React from "react";
import { Updater } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceTestType } from "@intelligems/ig-types";
import { Box, Grid } from "@mui/material";

import { ContentTestIcon } from "../../../../images/Icons/ContentTest/ContentTestIcon";
import { OfferTestIcon } from "../../../../images/Icons/Offer/OfferTestIcon";
import { PriceTestIconFilled } from "../../../../images/Icons/PriceTest/PriceTestIconFilled";
import { ShippingTestIcon } from "../../../../images/Icons/ShippingTest/ShippingTestIcon";
import theme from "../../../../theme";

const testOptions = [
  {
    title: "Content Testing",
    description: "A/B test site content, pages, and Shopify themes.",
    type: "content",
    iconBlue: <ContentTestIcon sx={{ fontSize: "40px" }} />,
    iconGreen: (
      <ContentTestIcon
        fill={theme.palette.success.main}
        sx={{ fontSize: "40px" }}
      />
    ),
  },
  {
    title: "Campaigns",
    type: "personalization",
    iconBlue: <OfferTestIcon />,
    iconGreen: <OfferTestIcon fill={theme.palette.success.main} />,
    description: "Elevate your promotions with precise, AOV-boosting offers.",
  },
  {
    title: "Price Testing",
    type: "pricing",
    description: "Experiment with A/B testing your product prices.",
    iconBlue: <PriceTestIconFilled sx={{ fontSize: "45px" }} />,
    iconGreen: (
      <PriceTestIconFilled
        // sx={{ fontSize: "45px" }}
        fill={theme.palette.success.main}
      />
    ),
  },
  {
    title: "Shipping Testing",
    type: "shipping",
    description: "A/B test shipping thresholds and shipping rates.",
    iconBlue: <ShippingTestIcon />,
    iconGreen: <ShippingTestIcon fill={theme.palette.success.main} />,
  },
];

interface ProductSelectionProps {
  setSelectedTestType: Updater<ExperienceTestType | "">;
  selectedTestType: ExperienceTestType | "";
  handleNext: () => void;
}
export const ProductSelection = ({
  setSelectedTestType,
  handleNext,
  selectedTestType,
}: ProductSelectionProps) => {
  return (
    <Grid container direction={"column"} rowSpacing={2}>
      <Grid item container columnSpacing={2} direction={"row"} rowSpacing={2}>
        {testOptions.map((option) => (
          <Grid item key={option.title} xs={6} sx={{ padding: 0 }}>
            <Box
              onClick={() => {
                setSelectedTestType(option.type as ExperienceTestType);
                handleNext();
              }}
              sx={{
                borderRadius: "15px",
                padding: "20px",
                paddingTop: "31px",
                backgroundColor:
                  selectedTestType === option.type ? "#f5f5f5" : "none",
                border: `1px solid ${
                  selectedTestType === option.type
                    ? theme.palette.success.main
                    : theme.palette.disabled.light
                }`,

                height: "122px",
                position: "relative",
                "&:hover": {
                  cursor: "pointer",
                  border: `1px solid ${
                    theme.palette[
                      selectedTestType === option.type ? "success" : "primary"
                    ].main
                  }`,
                },
              }}
            >
              {selectedTestType === option.type && (
                <Box
                  sx={{
                    borderTopRightRadius: "14px",
                    borderTopLeftRadius: "14px",
                    backgroundColor: theme.palette.success.main,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                  }}
                >
                  <Grid
                    item
                    container
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    sx={{ height: "25px" }}
                  >
                    <IgTypography
                      sx={{ color: "white", fontSize: "14px" }}
                      igStyle={"semibold"}
                    >
                      Selected
                    </IgTypography>
                  </Grid>
                </Box>
              )}
              <Grid item container direction={"column"}>
                <Grid
                  item
                  container
                  direction={"row"}
                  justifyContent={"space-between"}
                >
                  <Grid item container direction={"column"} xs={9}>
                    <Grid item>
                      <IgTypography
                        igStyle={"semibold"}
                        sx={{ fontSize: "18px" }}
                      >
                        {option.title}
                      </IgTypography>
                    </Grid>
                    <Grid item>
                      <IgTypography>{option.description}</IgTypography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  direction={"row"}
                  justifyContent={"flex-end"}
                >
                  <>
                    {selectedTestType === option.type
                      ? option.iconGreen
                      : option.iconBlue}
                  </>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        ))}
      </Grid>
      {selectedTestType !== "" && (
        <Grid item textAlign={"center"}>
          <IgButton
            sx={{ fontSize: "16px", width: "215px" }}
            variant={"contained"}
            onClick={handleNext}
          >
            Continue
          </IgButton>
        </Grid>
      )}
    </Grid>
  );
};
